import { useEffect } from 'react'

/**
 * FaqAccordion - makes every FAQ group behave as a single-open accordion.
 *
 * FAQ groups are marked with `[data-faq]` and contain native
 * <details>/<summary> elements (rendered by the homepage FAQ section in
 * Pentabay.html and by the faqBlock helper in pentabay-page-extras.js).
 * Native <details> allow several panels open at once; this overlay
 * enforces "only one open at a time" per group while keeping the
 * accessible native semantics (keyboard, focus, screen-reader
 * announcements) completely intact.
 *
 * The `toggle` event does not bubble, so we listen in the capture phase
 * (third arg `true`) to catch it on any <details> in the document -
 * including the sub-page FAQs that mount asynchronously after the route
 * scripts run. When one panel opens we close its open siblings in the
 * same `[data-faq]` container.
 */
export default function FaqAccordion() {
  useEffect(() => {
    function onToggle(e) {
      const details = e.target
      if (!(details instanceof HTMLElement) || details.tagName !== 'DETAILS') return
      if (!details.open) return
      const group = details.closest('[data-faq]')
      if (!group) return
      group.querySelectorAll(':scope > details[open]').forEach((d) => {
        if (d !== details) d.open = false
      })
    }
    document.addEventListener('toggle', onToggle, true)
    return () => document.removeEventListener('toggle', onToggle, true)
  }, [])
  return null
}
